export default "__VITE_ASSET__DlfgzsB9__"